import React, { useRef, useEffect } from 'react';
import { doScroll, focusMessageBox } from '../AlmeUtilities/dom-utils';
const initialScrollTimeout = 1000;
const scrollTimeout = 100;
const focusableElements = [
    'a[href]',
    'button',
    'input',
    'textarea',
    /** 'select', - using component library select */
    'details',
    '[tabindex]:not([tabindex="-1"])',
];
function elementFilter(el) {
    return !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden') && el.tagName.toLowerCase() !== "select";
}
function getKeyboardFocusableElements(element) {
    return [...element.querySelectorAll(focusableElements.join(','))].filter(elementFilter);
}
const ResponseFocusHandler = ({ responseId, children, isLastResponse, isInlineForm, isOverlayForm, fromHistory, disableResponseCard, }) => {
    const responseRef = useRef(null);
    const isInlineFocusable = isLastResponse && (!fromHistory || isInlineForm);
    /** To fix initial scrolling issue when entire page is refreshed */
    const stimeout = fromHistory ? initialScrollTimeout : scrollTimeout;
    useEffect(() => {
        if (!isLastResponse)
            return;
        if (isInlineFocusable && responseRef.current) {
            const currentFocusableElements = getKeyboardFocusableElements(responseRef.current);
            (currentFocusableElements.length >= 1 && currentFocusableElements[0].id !== "alme-survey-yes-button") ? currentFocusableElements[0].focus() : focusMessageBox();
        }
        else if (!isOverlayForm) {
            focusMessageBox();
        }
    }, [isInlineFocusable, isLastResponse, isOverlayForm]);
    useEffect(() => {
        let timeout;
        if (isLastResponse) {
            timeout = window.setTimeout(() => doScroll(responseRef), stimeout);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isLastResponse, stimeout]);
    return (React.createElement("div", { id: `response-card-${responseId}`, "aria-disabled": disableResponseCard, "aria-hidden": disableResponseCard, ref: responseRef }, children));
};
export default ResponseFocusHandler;
